import type { Article } from "./types";

export const socialRelationshipsArticles: Article[] = [];
